import React from "react";
import "./HelperText.css";

interface HelperTextProps {
  message: string;
  type?: "error" | "info" | "success" | "warning";
  className?: string;
  children?: React.ReactNode;
}

const HelperText: React.FC<HelperTextProps> = ({
  message,
  type = "info",
  className = "",
  children,
}) => (
  <div className={`helper-text helper-text-${type} ${className}`}>
    {message}
    {children}
  </div>
);

export default HelperText;
